/**
 * contact-form.js — kiểm tra dữ liệu form Liên hệ và giả lập gửi (bản HTML tĩnh).
 *
 * Markup cần:
 *   form[data-contact-form][novalidate]
 *     .field > label + .input/.select/.textarea[required][data-error="…"]
 *                                             [data-error-pattern="…"] (tel / email sai dạng)
 *     .field > label.checkbox > input[type=checkbox][required][data-error]
 *     button[type=submit][data-loading-label] (trạng thái "Đang gửi…" do form-loading.js lo)
 *   .modal#contact-success — mở bằng #hash, modal.js bắt hashchange.
 *
 * Lỗi hiện theo mục 09: .field--error (viền + nhãn đỏ) + .field__error bên dưới ô,
 * nối vào ô bằng aria-describedby + aria-invalid; focus về ô sai đầu tiên. Câu báo lỗi
 * nằm trong data-error của HTML để PHP dịch được — JS không giữ chữ nào.
 *
 * Thứ tự với form-loading.js: listener ở đây gắn pha CAPTURE trên form nên luôn chạy
 * trước listener thường của form-loading.js (không phụ thuộc thứ tự gulp gộp file).
 * Form sai → chặn luôn sự kiện, nút không bị chuyển sang "Đang gửi…" oan.
 *
 * WP: form POST thật tới admin-post.php rồi redirect kèm #contact-success. Khi đó chỉ giữ
 * phần kiểm tra dữ liệu, bỏ đoạn giả lập (fakeSend) — server mới là nơi kiểm tra cuối.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var form = document.querySelector('[data-contact-form]');
    if (!form) return;

    var SUCCESS_HASH = 'contact-success';
    var FAKE_DELAY = 900;

    // Số di động / cố định Việt Nam: 0 hoặc +84 rồi 9 chữ số, cho phép dấu cách và dấu chấm
    var PHONE_RE = /^(\+84|0)\d{9}$/;

    var controls = [].slice.call(form.querySelectorAll('input:not([type="hidden"]):not([name="website"]), select, textarea'));

    function fieldOf(control) {
        return control.closest ? control.closest('.field') : null;
    }

    // Trả về câu báo lỗi, hoặc '' nếu ô hợp lệ
    function check(control) {
        var value = control.type === 'checkbox' ? '' : control.value.trim();

        if (control.type === 'checkbox') {
            return control.required && !control.checked ? control.getAttribute('data-error') || '' : '';
        }

        if (!value) {
            return control.required ? control.getAttribute('data-error') || '' : '';
        }

        if (control.type === 'tel' && !PHONE_RE.test(value.replace(/[\s.]/g, ''))) {
            return control.getAttribute('data-error-pattern') || '';
        }

        // novalidate chỉ tắt bong bóng báo lỗi của trình duyệt, validity vẫn được tính
        if (control.type === 'email' && control.validity && control.validity.typeMismatch) {
            return control.getAttribute('data-error-pattern') || '';
        }

        return '';
    }

    function show(control, message) {
        var field = fieldOf(control);
        if (!field) return;

        var id = control.id + '-error';
        var note = document.getElementById(id);

        field.classList.toggle('field--error', !!message);

        if (!message) {
            control.removeAttribute('aria-invalid');
            if (note) note.parentNode.removeChild(note);
            unlink(control, id);
            return;
        }

        control.setAttribute('aria-invalid', 'true');

        if (!note) {
            note = document.createElement('div');
            note.className = 'field__error';
            note.id = id;
            field.appendChild(note);
        }

        note.textContent = message;
        link(control, id);
    }

    // aria-describedby có thể đã chứa id khác (vd .field__help) — chỉ thêm/bớt id của mình
    function link(control, id) {
        var ids = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
        if (ids.indexOf(id) === -1) ids.push(id);
        control.setAttribute('aria-describedby', ids.join(' '));
    }

    function unlink(control, id) {
        var ids = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (item) {
            return item && item !== id;
        });

        if (ids.length) control.setAttribute('aria-describedby', ids.join(' '));
        else control.removeAttribute('aria-describedby');
    }

    function validate() {
        var firstBad = null;

        controls.forEach(function (control) {
            var message = check(control);
            show(control, message);
            if (message && !firstBad) firstBad = control;
        });

        return firstBad;
    }

    // Ô đang báo lỗi thì kiểm lại ngay khi sửa, để lỗi biến mất lúc vừa gõ đúng —
    // ô chưa báo lỗi thì để yên, không mắng người dùng khi họ còn đang gõ dở.
    controls.forEach(function (control) {
        var eventName = control.type === 'checkbox' || control.tagName === 'SELECT' ? 'change' : 'input';

        control.addEventListener(eventName, function () {
            if (control.getAttribute('aria-invalid') === 'true') show(control, check(control));
        });
    });

    function fakeSend() {
        var submit = form.querySelector('[type="submit"]');
        var label = submit ? submit.querySelector('[data-loading-target]') : null;
        var idle = label ? label.textContent : '';

        window.setTimeout(function () {
            form.reset();

            // Bản tĩnh không chuyển trang nên form-loading.js không bao giờ tự gỡ trạng
            // thái "Đang gửi…" (nó chỉ gỡ ở pageshow) — trả nút về như cũ tại đây.
            if (submit) {
                submit.disabled = false;
                submit.classList.remove('is-loading');
                submit.removeAttribute('aria-busy');
                if (label) label.textContent = idle;
            }

            window.location.hash = SUCCESS_HASH;
        }, FAKE_DELAY);
    }

    form.addEventListener(
        'submit',
        function (event) {
            var firstBad = validate();

            // Bản tĩnh không có server: luôn chặn gửi thật
            event.preventDefault();

            if (firstBad) {
                event.stopImmediatePropagation();
                firstBad.focus();
                return;
            }

            fakeSend();
        },
        true
    );
})();
